import React from "react";
import { Link } from "react-router-dom";
import { Activity, Instagram, Facebook, Youtube, Linkedin, Twitter, MessageCircle } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const ICONS = { instagram: Instagram, facebook: Facebook, youtube: Youtube, linkedin: Linkedin, x: Twitter, twitter: Twitter, whatsapp: MessageCircle };

export const Footer = ({ content }) => {
  const socials = (content?.social_links || []).filter((s) => s.enabled && s.url);
  const legal = content?.legal || {};
  return (
    <footer id="contact" className="relative bg-[#080d18] border-t border-white/10 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-5">
            <Activity className="h-7 w-7 text-[#FF4D00]" strokeWidth={2.5} />
            <span className="font-display text-2xl tracking-wide">COORG<span className="text-[#FF4D00]">·</span>INFINITY</span>
          </div>
          <p className="text-white/50 max-w-md text-sm leading-relaxed">
            {content?.about_body?.slice(0, 160) || "Run beyond limits."}
          </p>
          {socials.length > 0 && (
            <div className="flex gap-4 mt-6" data-testid="footer-socials">
              {socials.map((s) => {
                const Icon = ICONS[s.platform] || Activity;
                return (
                  <a key={s.platform} href={s.url} target="_blank" rel="noreferrer"
                    className="h-10 w-10 border border-white/15 flex items-center justify-center hover:border-[#FF4D00] hover:text-[#FF4D00] transition-colors"
                    data-testid={`social-${s.platform}`} title={s.platform}>
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          )}
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF4D00] mb-5">Support</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li data-testid="footer-email">{content?.contact_email}</li>
            <li data-testid="footer-phone">{content?.contact_phone}</li>
            {content?.contact_whatsapp && <li data-testid="footer-whatsapp">WhatsApp: {content.contact_whatsapp}</li>}
            <li>{content?.contact_address}</li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF4D00] mb-5">Links</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link to="/register" className="hover:text-white">Register</Link></li>
            <li><a href="/#faq" className="hover:text-white">FAQs</a></li>
            <li><a href={mediaUrl(legal.terms_pdf_url) || "/legal/Terms.pdf"} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-terms">Terms & Conditions</a></li>
            <li><a href={mediaUrl(legal.privacy_pdf_url) || "/legal/Privacy.pdf"} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-14 pt-6 border-t border-white/10 text-xs text-white/60">
        {content?.footer_text || "© 2027 Coorg Infinity Run. All rights reserved."}
      </div>
    </footer>
  );
};
